/* ============================================================
   PDP V2 — test A/B Prostar Whey

   REGLA DEL PROYECTO: cambia el look, no el funcionamiento.
   La V2 no tiene formulario ni lógica de compra propia: los controles de la
   V1 siguen vivos en el DOM (fuera de pantalla por CSS) y son los que
   ejecutan todo. Ante la duda, accionar el control real de la V1 en vez de
   reimplementarlo. Este tema está muy a medida (carro propio por Storefront
   GraphQL, atributos data-* como fuente de verdad) y reimplementar rompe
   cosas en silencio.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-pdp-v2]');
  if (!root) return;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ---------- Datos de variantes ----------
     Importes ya formateados desde Liquid con `money`. Shopify guarda los
     precios en la subunidad (CLP $92.990 -> 9299000): hacer aritmética de
     moneda en JS es pedir un error. */
  var VARIANTES = {};
  var nodoDatos = document.getElementById('pdp-v2-variantes');
  if (nodoDatos) {
    try { VARIANTES = JSON.parse(nodoDatos.textContent); }
    catch (err) { VARIANTES = {}; }
  }

  /* ---------- 1. Chips de sabor -> controles de la V1 ---------- */

  function radioDeSabor(valor) {
    var todos = $$('.js-get-variant');
    for (var i = 0; i < todos.length; i++) {
      if (todos[i].value === valor) return todos[i];
    }
    return null;
  }

  function labelDeRadio(radio) {
    if (!radio || !radio.id) return null;
    var id = (window.CSS && CSS.escape) ? CSS.escape(radio.id) : radio.id;
    return document.querySelector('label[for="' + id + '"]');
  }

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-v2-sabor]');
    if (!chip || chip.disabled) return;

    e.preventDefault();
    var valor = chip.getAttribute('data-v2-sabor');
    var radio = radioDeSabor(valor);
    if (!radio || radio.disabled) return;

    // Se hace click en el <LABEL>, no en el input y no con un `change`.
    // Verificado sobre el tema real:
    //   - radio.click() no hace nada: el input lleva visibility:hidden y el
    //     handler del tema hace preventDefault.
    //   - despachar `change` actualiza el SKU visible pero NO el
    //     `data-product-variant-id` del botón, que es de donde el tema saca
    //     la variante que manda al carro: la ficha mostraba un sabor y se
    //     agregaba otro.
    //   - click en el <label> es lo que hace un usuario y dispara el handler
    //     real, que resuelve la variante con un $.getJSON asíncrono.
    var label = labelDeRadio(radio);
    if (label) { label.click(); } else { radio.click(); }

    sincronizarV2(valor, radio);
  });

  /* ---------- 2. Sincronizar la vista de la V2 ---------- */

  $$('.js-get-variant').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (radio.checked) sincronizarV2(radio.value, radio);
    });
  });

  /* Arranque de la galería: las miniaturas se emiten con `hidden` para no
     mostrar el set completo de sabores mientras carga el script, así que hay
     que revelar las del sabor activo apenas se puede. El sabor de partida sale
     del radio que la V1 trae marcado con `active` (esta plantilla usa esa
     clase, no `checked`). */
  (function iniciarGaleria() {
    var activo = $('.js-get-variant.active') || $('.js-get-variant');
    if (activo) actualizarFoto(activo.value);
  })();

  function sincronizarV2(valor, radio) {
    $$('[data-v2-sabor]', root).forEach(function (c) {
      c.classList.toggle('is-active', c.getAttribute('data-v2-sabor') === valor);
    });

    var etiqueta = $('[data-v2-sabor-actual]', root);
    if (etiqueta) {
      etiqueta.textContent = valor.charAt(0).toUpperCase() + valor.slice(1).toLowerCase();
    }

    var sku = $('[data-v2-sku]', root);
    var skuNuevo = radio && radio.getAttribute('data-variant-sku');
    if (sku && skuNuevo) sku.textContent = skuNuevo;

    actualizarPrecio(valor);
    actualizarFoto(valor);
    actualizarCertificaciones(valor);
    actualizarStats(valor);
    sincronizarDisponibilidad(valor);
  }

  /* ---------- 3. Precio y derivados ---------- */

  function mostrar(el, visible) { if (el) el.hidden = !visible; }

  function actualizarPrecio(valorOpcion) {
    var v = VARIANTES[valorOpcion];
    if (!v) return;

    /* El precio actual se pinta en DOS lugares: la tarjeta de precio y la
       barra sticky del móvil. Por eso acá va querySelectorAll y no $(). */
    var actuales = root.querySelectorAll('[data-v2-precio-actual]');
    var elAntes  = $('[data-v2-precio-antes]', root);
    var elOff    = $('[data-v2-precio-off]', root);
    var elKg     = $('[data-v2-precio-kg]', root);
    var elAhorro = $('[data-v2-precio-ahorro]', root);

    Array.prototype.forEach.call(actuales, function (el) { el.textContent = v.precio_fmt; });
    if (elAntes) elAntes.textContent = v.antes_fmt;
    if (elOff) elOff.textContent = '-' + v.pct + '%';
    if (elAhorro) elAhorro.textContent = 'Ahorras ' + v.ahorro_fmt;

    mostrar(elAntes, v.hay_descuento);
    mostrar(elOff, v.hay_descuento);
    mostrar(elAhorro, v.hay_descuento);

    if (elKg) {
      if (v.kg_fmt) elKg.textContent = v.kg_fmt + ' por kg';
      mostrar(elKg, !!v.kg_fmt);
    }

    var badge = $('.pdp-v2-gal__badge--off', root);
    if (badge) {
      badge.textContent = v.pct + '% OFF';
      badge.hidden = !v.hay_descuento;
    }
  }

  /* La galería lleva TODAS las imágenes del producto, cada una etiquetada con
     su sabor en `data-v2-alt`. Acá se muestran solo las del sabor activo, que
     es exactamente la regla de la V1 (`alt === activeVariantValue` en
     product-image-slider.liquid y js-product-template.js).

     Sin esto la galería mezclaba sabores: se veía la foto de chocolate y a
     continuación las tablas nutricionales de chocolate, plátano y frutilla. */
  function actualizarFoto(valorOpcion) {
    var visibles = 0;

    $$('[data-v2-thumb]', root).forEach(function (t) {
      var suyo = t.getAttribute('data-v2-alt') === valorOpcion;
      t.hidden = !suyo;
      t.classList.toggle('is-active', suyo && visibles === 0);
      if (suyo) visibles++;
    });

    /* Si el sabor no tiene imágenes propias no se deja la galería vacía: se
       muestran todas, que es preferible a un marco en blanco. */
    if (!visibles) {
      $$('[data-v2-thumb]', root).forEach(function (t, n) {
        t.hidden = false;
        t.classList.toggle('is-active', n === 0);
        visibles++;
      });
    }

    var primera = thumbsVisibles()[0];
    var foto = document.getElementById('pdp-v2-foto');
    if (foto && primera) foto.src = primera.getAttribute('data-v2-thumb');

    /* La miniatura de la barra flotante sigue al sabor activo. */
    var flotImg = $('[data-v2-flot-img]', root);
    if (flotImg && primera) flotImg.src = primera.getAttribute('data-v2-thumb');

    /* Las flechas solo tienen sentido con más de una foto del sabor. */
    $$('[data-v2-nav]', root).forEach(function (b) { b.hidden = visibles < 2; });
  }

  /* Certificaciones: son POR VARIANTE (badge_variant_tags). Se renderizan
     todos los juegos y se muestra el del sabor activo, igual que hace la V1
     con la clase `active`. Si el sabor no tiene, el bloque se esconde. */
  function actualizarCertificaciones(valor) {
    var bloque = $('[data-v2-certs-bloque]', root);
    if (!bloque) return;

    var alguno = false;
    $$('[data-v2-certs-sabor]', bloque).forEach(function (set) {
      var suyo = set.getAttribute('data-v2-certs-sabor') === valor;
      set.classList.toggle('is-active', suyo);
      if (suyo) alguno = true;
    });
    bloque.hidden = !alguno;
  }

  /* Franja de cifras: precio por batido de la variante activa y, si esa
     variante está en descuento, se muestra el % en vez de "100% original". */
  function actualizarStats(valor) {
    var v = VARIANTES[valor];
    var stats = $('[data-v2-stats]');
    if (!v || !stats) return;

    var porcion = $('[data-v2-stats-porcion]', stats);
    if (porcion && v.porcion_fmt) porcion.textContent = v.porcion_fmt;

    var off = $('[data-v2-stats-off]', stats);
    if (off) off.textContent = v.pct + '%';

    var cajaOff = $('[data-v2-stats-descuento]', stats);
    var cajaOrig = $('[data-v2-stats-original]', stats);
    if (cajaOff) cajaOff.hidden = !v.hay_descuento;
    if (cajaOrig) cajaOrig.hidden = !!v.hay_descuento;
  }

  /* ---------- 4. Galería: miniaturas y flechas ---------- */

  /* Solo las del sabor activo: el resto están en el DOM pero ocultas, así que
     las flechas y el índice tienen que ignorarlas o saltarían a fotos de otro
     sabor. */
  function thumbsVisibles() {
    return $$('[data-v2-thumb]', root).filter(function (t) { return !t.hidden; });
  }

  function indiceActual() {
    var thumbs = thumbsVisibles();
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function mostrarFoto(indice) {
    var thumbs = thumbsVisibles();
    if (!thumbs.length) return;

    var i = ((indice % thumbs.length) + thumbs.length) % thumbs.length;
    var foto = document.getElementById('pdp-v2-foto');
    if (foto) foto.src = thumbs[i].getAttribute('data-v2-thumb');

    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
  }

  root.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-v2-thumb]');
    if (thumb) {
      /* El índice va contra las VISIBLES, no contra la lista completa: en el
         DOM están las imágenes de los ocho sabores, así que el índice global
         de una miniatura no tiene ninguna relación con su posición dentro del
         sabor activo. */
      mostrarFoto(thumbsVisibles().indexOf(thumb));
      return;
    }
    var nav = e.target.closest('[data-v2-nav]');
    if (nav) {
      mostrarFoto(indiceActual() + parseInt(nav.getAttribute('data-v2-nav'), 10));
    }
  });

  /* ---------- 4b. Botón de video ----------
     El snippet `video-popup` del tema monta una burbuja flotante que el
     visitante puede cerrar; al cerrarla el snippet la borra y lo recuerda en
     sessionStorage. Si el botón del carrusel dependiera de esa burbuja,
     dejaría de funcionar para el resto de la sesión. Por eso abre su propio
     overlay con la URL que viene desde Liquid: es la única pieza que se
     reimplementa, y se justifica porque es presentación pura y el control
     original es descartable por diseño. */

  function abrirVideo(url) {
    if (!url || document.getElementById('pdp-v2-video-ov')) return;

    var ov = document.createElement('div');
    ov.id = 'pdp-v2-video-ov';
    ov.className = 'pdp-v2-video-ov';
    ov.innerHTML =
      '<div class="pdp-v2-video-ov__marco">' +
        '<button type="button" class="pdp-v2-video-ov__x" aria-label="Cerrar video">&#10005;</button>' +
        '<video controls autoplay playsinline preload="auto"></video>' +
      '</div>';
    document.body.appendChild(ov);

    var vid = ov.querySelector('video');
    vid.src = url;
    document.body.style.overflow = 'hidden';

    function cerrar() {
      try { vid.pause(); } catch (err) {}
      ov.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', esc);
    }
    function esc(ev) { if (ev.key === 'Escape') cerrar(); }

    ov.querySelector('.pdp-v2-video-ov__x').addEventListener('click', cerrar);
    ov.addEventListener('click', function (ev) { if (ev.target === ov) cerrar(); });
    document.addEventListener('keydown', esc);
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-v2-video]');
    if (!btn) return;
    abrirVideo(btn.getAttribute('data-v2-video-url'));
  });

  /* ---------- 4c. "Ver N más" sabores ---------- */

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-v2-sabores-mas]');
    if (!btn) return;

    var abierto = btn.getAttribute('aria-expanded') === 'true';
    var extras = $$('[data-v2-sabor-extra]', root);
    extras.forEach(function (c) { c.hidden = abierto; });
    btn.setAttribute('aria-expanded', String(!abierto));
    btn.textContent = abierto ? 'Ver ' + extras.length + ' más' : 'Ver menos';
  });

  /* ---------- 5. Cantidad -> controles reales de la V1 ----------
     IMPORTANTE: el tema NO lee la cantidad del input. js-product-template.js
     la toma de `data-product-quantity` del propio botón de compra, y ese
     atributo solo lo escriben los handlers de [name=plus] / [name=minus].
     (El handler de `change` del input nunca corre: su selector delegado es
     `.c-quantity__input input[type="number"]`, pero esa clase está en el
     input mismo. Bug preexistente del tema; no lo tocamos.)
     Por eso la V2 acciona los botones reales: escribir el input dejaba la
     ficha mostrando 2 y agregaba 1 al carro. */

  function inputCantidadV1() {
    return $('input[name="quantity"][data-actual-product-qty]');
  }

  function botonCantidadV1(signo) {
    return $('[js-product-template] [name="' + (signo > 0 ? 'plus' : 'minus') + '"]');
  }

  function reflejarCantidadEnV2() {
    var v1 = inputCantidadV1();
    var campo = $('[data-v2-cant-input]', root);
    if (v1 && campo) campo.value = parseInt(v1.value, 10) || 1;
  }

  root.addEventListener('click', function (e) {
    var paso = e.target.closest('[data-v2-cant]');
    if (!paso) return;

    var real = botonCantidadV1(parseInt(paso.getAttribute('data-v2-cant'), 10));
    if (real) real.click();

    setTimeout(reflejarCantidadEnV2, 0);
  });

  var campoCant = $('[data-v2-cant-input]', root);
  if (campoCant) {
    campoCant.addEventListener('change', function () {
      var v1 = inputCantidadV1();
      var min = v1 && parseInt(v1.min, 10) ? parseInt(v1.min, 10) : 1;
      var objetivo = parseInt(campoCant.value, 10);
      if (!objetivo || objetivo < min) objetivo = min;

      // Se replican las tres operaciones del tema en sus handlers de +/-.
      if (v1) {
        v1.value = objetivo;
        if (window.jQuery) { window.jQuery(v1).trigger('change'); }
        else { v1.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      $$('.js-add-product-template').forEach(function (b) {
        b.setAttribute('data-product-quantity', objetivo);
      });

      campoCant.value = objetivo;
    });
  }

  reflejarCantidadEnV2();

  /* ---------- 6. Botones de compra -> botones reales de la V1 ----------
     No se reimplementa nada del carro: el tema usa Storefront GraphQL
     (window.CartAPI.addOrUpdateItems), arma atributos de línea a medida
     (outlet, packs, promos, retiro en tienda) y republica el evento a los
     Web Pixels. Todo eso vive en los handlers de la V1. */

  root.addEventListener('click', function (e) {
    var add = e.target.closest('[data-v2-add]');
    var buy = e.target.closest('[data-v2-buy]');
    if (!add && !buy) return;

    var real = document.getElementById(add ? 'normalAddToCartBtn' : 'addAndGoCheckout');
    if (!real || real.disabled) return;

    real.click();
  });

  /* ---------- 6b. Barra flotante de compra ----------
     Se muestra cuando la barra de compra sale de pantalla. Se resuelve con
     IntersectionObserver y no escuchando el scroll: el navegador avisa solo
     en los dos cruces, en vez de ejecutar código en cada píxel de scroll a lo
     largo de una ficha que mide varios miles de píxeles.

     El observador corre también en desktop, pero ahí el CSS la mantiene en
     display:none, así que no hace falta acoplar el JS al breakpoint. */
  (function barraFlotante() {
    var flot = $('[data-v2-flot]', root);
    var ancla = $('.pdp-v2-cta-barra', root);
    if (!flot || !ancla) return;

    if (!('IntersectionObserver' in window)) { flot.hidden = false; return; }

    new IntersectionObserver(function (entradas) {
      var e = entradas[0];

      /* No alcanza con `!isIntersecting`: eso también es cierto ANTES de
         llegar a los botones, cuando todavía están más abajo en la página, y
         la barra aparecía apenas cargaba la ficha.

         La barra solo tiene sentido una vez que los botones quedaron ARRIBA
         del viewport, o sea cuando el visitante ya los pasó bajando. Eso se
         distingue mirando de qué lado quedó la caja. */
      var techo = e.rootBounds ? e.rootBounds.top : 0;
      var yaLosPaso = !e.isIntersecting && e.boundingClientRect.bottom <= techo;

      flot.hidden = !yaLosPaso;
    }, { threshold: 0 }).observe(ancla);
  })();

  /* ---------- 7. Disponibilidad ---------- */

  /* El estado sale de VARIANTES, el JSON que Liquid emite con el stock de cada
     variante. Es un dato que ya tenemos al renderizar, así que se resuelve en
     el mismo instante en que se cambia de sabor.

     Antes se espejaba el botón real de la V1 con un MutationObserver sobre su
     `disabled`. El tema lo deshabilita un momento mientras recalcula la
     variante, así que al cambiar de sabor el botón parpadeaba "Agotado" y
     volvía a habilitarse. Ese parpadeo era nuestro, no del stock.

     No se pierde ninguna protección al dejar de mirarlo:
       - los sabores sin stock se renderizan `disabled` y no se pueden elegir
         (ver pdp-v2-sabores.liquid);
       - el proxy del click ya se niega a disparar si el botón real está
         deshabilitado, sea cual sea el motivo. */
  function sincronizarDisponibilidad(valor) {
    var v = VARIANTES[valor];
    var agotado;

    if (v) {
      agotado = v.disponible === false;
    } else {
      /* Sin datos de variante (producto de variante única), se cae al estado
         del botón real. Se lee una sola vez, no en cada mutación, así que no
         reintroduce el parpadeo. */
      var real = document.getElementById('normalAddToCartBtn');
      agotado = !!real && (real.disabled || real.classList.contains('unavailable'));
    }

    /* Hay DOS botones de agregar: el de la zona de compra y el de la barra
       flotante. Los dos tienen que quedar agotados a la vez, pero NO comparten
       texto: el de la flotante dice "Agregar" a secas porque la tarjeta es
       angosta. Por eso se guarda la etiqueta original de cada uno la primera
       vez y se restaura desde ahí, en vez de escribir una constante que le
       pisaría el texto corto al de la barra. */
    var v2buy = $('[data-v2-buy]', root);

    $$('[data-v2-add]', root).forEach(function (b) {
      if (!b.getAttribute('data-v2-label')) {
        b.setAttribute('data-v2-label', b.textContent.trim());
      }
      b.disabled = agotado;
      b.textContent = agotado ? 'Agotado' : b.getAttribute('data-v2-label');
    });

    if (v2buy) v2buy.disabled = agotado;
  }

  (function iniciarDisponibilidad() {
    var activo = $('.js-get-variant.active') || $('.js-get-variant');
    sincronizarDisponibilidad(activo ? activo.value : null);
  })();

  /* ---------- 8. Reubicar bloques externos (nunca duplicarlos) ---------- */

  function reubicar(selectores, slotSel) {
    var slot = $(slotSel, root);
    if (!slot) return false;

    var movido = false;
    selectores.forEach(function (sel) {
      var nodo = $(sel);
      if (!nodo) return;
      if (slot.contains(nodo)) { movido = true; return; }
      slot.appendChild(nodo);
      movido = true;
    });
    return movido;
  }

  function reubicarEntrega() {
    // Sufijo de id, no id completo: en plantillas JSON Shopify antepone
    // `template--<id>__` y ese <id> cambia de un tema a otro.
    return reubicar(
      ['.c-delivery-type', '[id$="__16794389217bd57f41"]'],
      '[data-v2-slot-entrega]'
    );
  }

  /* Recomendador de Insider.
     Insider no usa el `#smart-recommender-section` que el tema deja listo:
     inyecta su bloque dentro del `.container` de la sección `main`, que en el
     brazo B está fuera de pantalla. Movemos el nodo real (su
     `.ins-preview-wrapper`) al slot de la V2.

     Ojo: hay varios `.ins-preview-wrapper` en la página (uno es la pestaña
     lateral fija). Por eso se localiza a partir del recomendador y se sube al
     wrapper, en vez de tomar el primero que aparezca. */
  function reubicarRecomendador() {
    var slot = $('[data-v2-slot-reco]', root);
    if (!slot) return false;

    var reco = $('.ins-web-smart-recommender-main-wrapper');
    if (!reco) return false;

    var wrapper = reco.closest('.ins-preview-wrapper') || reco;
    if (slot.contains(wrapper)) return true;

    slot.appendChild(wrapper);
    return true;
  }

  function reubicarTodo() {
    var a = reubicarEntrega();
    var b = reubicarRecomendador();
    return a && b;
  }

  // Insider inyecta de forma asíncrona y puede tardar varios segundos, así
  // que se reintenta con techo de 30s y además se observa el DOM.
  if (!reubicarTodo()) {
    var intentos = 0;
    var reloj = setInterval(function () {
      intentos++;
      if (reubicarTodo() || intentos > 60) clearInterval(reloj);
    }, 500);
  }

  if (window.MutationObserver) {
    var obsIns = new MutationObserver(function () { reubicarRecomendador(); });
    obsIns.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obsIns.disconnect(); }, 30000);
  }

  /* ---------- 9. Acordeón ---------- */

  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-v2-acc]');
    if (!head) return;

    var abierto = head.getAttribute('aria-expanded') === 'true';
    var cuerpo = document.getElementById(head.getAttribute('aria-controls'));

    head.setAttribute('aria-expanded', String(!abierto));
    if (cuerpo) cuerpo.hidden = abierto;

    var icono = $('.pdp-v2-acc__i', head);
    if (icono) icono.textContent = abierto ? '+' : '−';
  });

  /* ---------- 10. Filtro de reseñas por sabor ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-v2-rev-filtro]');
    if (!btn) return;

    var sabor = btn.getAttribute('data-v2-rev-filtro');

    $$('[data-v2-rev-filtro]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });

    $$('[data-v2-rev-sabor]').forEach(function (card) {
      card.hidden = sabor !== '' && card.getAttribute('data-v2-rev-sabor') !== sabor;
    });
  });

  (function podarFiltros() {
    var sabores = {};
    $$('[data-v2-rev-sabor]').forEach(function (c) {
      sabores[c.getAttribute('data-v2-rev-sabor')] = true;
    });
    $$('[data-v2-rev-filtro]').forEach(function (b) {
      var s = b.getAttribute('data-v2-rev-filtro');
      if (s !== '' && !sabores[s]) b.hidden = true;
    });
  })();

  /* ---------- 11. "Ver todas" -> widget nativo de Judge.me ---------- */

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-v2-rev-todas]')) return;

    var widget = $('.jdgm-widget, .jdgm-review-widget');
    if (!widget) return;

    var contenedor = widget.closest('[id^="shopify-section-"]');
    if (contenedor) contenedor.style.display = 'block';

    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- 12. Instrumentación del test ----------
     Corre en LOS DOS brazos: la sección V2 se renderiza siempre, solo que
     oculta. Si solo reportara el brazo B no habría denominador.
     NOTA: en esta tienda GA4 entra vía GTM (GTM-TZKX5VKZ). El push al
     dataLayer necesita un tag de GA4 en GTM que escuche el evento
     personalizado `experiment_impression`, si no, no llega a GA4. */

  (function reportarBrazo() {
    var brazo = document.documentElement.classList.contains('pdp-v2') ? 'B' : 'A';
    var datos = {
      exp_id: 'pdp_prostar_v2',
      exp_arm: brazo,
      item_id: root.getAttribute('data-v2-producto') || ''
    };

    function enviar() {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'experiment_impression', datos);
        return true;
      }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({
          event: 'experiment_impression',
          exp_id: datos.exp_id,
          exp_arm: datos.exp_arm,
          item_id: datos.item_id
        });
        return true;
      }
      return false;
    }

    if (!enviar()) {
      var n = 0;
      var reloj2 = setInterval(function () {
        n++;
        if (enviar() || n > 20) clearInterval(reloj2);
      }, 500);
    }
  })();

})();
